import { render, staticRenderFns } from "./OrderMenuGridWide.vue?vue&type=template&id=29b5237a&scoped=true"
import script from "./OrderMenuGridWide.vue?vue&type=script&lang=js"
export * from "./OrderMenuGridWide.vue?vue&type=script&lang=js"
import style0 from "./OrderMenuGridWide.vue?vue&type=style&index=0&id=29b5237a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b5237a",
  null
  
)

export default component.exports